import SectionCategoryRecommended from './SectionCategoryRecommended';
export default SectionCategoryRecommended;
